export const formatNumber = (number) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const formatFecha = (fecha) => {
  const anio = fecha.substr(0, 4);
  const mes = fecha.substr(5, 2);
  const dia = fecha.substr(8);
  return dia + " de " + MESES[mes - 1] + " de " + anio;
};
